import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";

export const NeedsColumns: GridColDef[] = [
  {
    field: "needId",
    headerName: "Ref. No.",
    width: 150,
    sortable: false,
    filterable: false,
  },
  {
    field: "name",
    headerName: "Full Name",
    width: 150,
    sortable: false,
    filterable: false,
  },
  {
    field: "mobileNumber",
    headerName: "Contact Number",
    width: 150,
    sortable: false,
    filterable: false,
  },
  {
    field: "category",
    headerName: "Category",
    width: 150,
    sortable: false,
    filterable: false,
  },
  {
    field: "subCategory",
    headerName: "Sub Category",
    width: 150,
    sortable: false,
    filterable: false,
  },
  {
    field: "area",
    headerName: "Area",
    width: 150,
    sortable: false,
    filterable: false,
  },
  {
    field: "state",
    headerName: "State",
    width: 150,
    sortable: false,
    filterable: false,
  },
  {
    field: "city",
    headerName: "City",
    width: 150,
    sortable: false,
    filterable: false,
  },
  {
    field: "district",
    headerName: "District",
    width: 150,
    sortable: false,
    filterable: false,
  },
  {
    field: "status",
    headerName: "Status",
    width: 150,
    sortable: false,
    filterable: false,
  },
  {
    field: "createdAt",
    headerName: "Submitted Date",
    width: 160,
    sortable: false,
    filterable: false,
    renderCell: (e) => {
      return dayjs(e.value).format("DD-MM-YYYY hh:mm A");
    },
  },
  {
    field: "systemCategory",
    headerName: "SysGen Category",
    width: 160,
    sortable: false,
    filterable: false,
  },
  {
    field: "systemSubCategory",
    headerName: "SysGen Sub Category",
    width: 160,
    sortable: false,
    filterable: false,
  },
  {
    field: "systemSubCompany",
    headerName: "SysGen Company",
    width: 160,
    sortable: false,
    filterable: false,
  },
  {
    field: "systemBrand",
    headerName: "SysGen Sub Brand",
    width: 160,
    sortable: false,
    filterable: false,
  },
];